import React from 'react';
import "../../../assets/css/customer/publicCustomerCss/home.css";
import { Container } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';

// Subscreens
import AboutUs from '../../../subscreens/customer/PublicCustomerSubscreens/AboutUs/AboutUs';
import Services from '../../../subscreens/customer/PublicCustomerSubscreens/services/Services';
import TestimonialsSlider from '../../../subscreens/customer/PublicCustomerSubscreens/Tesimonial/TestimonialsSlider';
import PackageSlider from '../../../subscreens/customer/PublicCustomerSubscreens/packages/PcakagesSlider';
import Videosection from '../../../subscreens/customer/PublicCustomerSubscreens/Videosection';

// GridMotion
import GridMotion from '../../../components/customer/PublicCustomerScreens/GridMotion/GridMotion';
import img1 from '../../../assets/images/img1.jpg';
import img2 from '../../../assets/images/img2.jpg';
import img3 from '../../../assets/images/img3.jpg';
import img4 from '../../../assets/images/img4.jpg';
import img5 from '../../../assets/images/img5.jpg';
import img6 from '../../../assets/images/img6.jpg';
import img7 from '../../../assets/images/img7.jpg';
import img8 from '../../../assets/images/img8.jpg';
import img9 from '../../../assets/images/img9.jpg';
import img10 from '../../../assets/images/img10.jpg';
import img11 from '../../../assets/images/img11.jpg';
import img12 from '../../../assets/images/img12.jpg';
import img13 from '../../../assets/images/img13.jpg';
import img14 from '../../../assets/images/img14.jpg';
import img15 from '../../../assets/images/img15.jpg';
import img16 from '../../../assets/images/img16.jpg';
import img17 from '../../../assets/images/img17.jpg';
import img18 from '../../../assets/images/img18.jpg';
import img19 from '../../../assets/images/img19.jpg';
import img20 from '../../../assets/images/img20.jpg';
import img21 from '../../../assets/images/img21.jpg';
import img22 from '../../../assets/images/img22.jpg';
import img23 from '../../../assets/images/img23.jpg';
import img24 from '../../../assets/images/img24.jpg';
import img25 from '../../../assets/images/img25.jpg';
import img26 from '../../../assets/images/img26.jpg';
import img27 from '../../../assets/images/img27.jpg';
import img28 from '../../../assets/images/img28.jpg';

const Home = () => {
  const navigate = useNavigate();
  const gridItems = [
    img1, img2, img3, img4, img5, img6, img7, img8,
    img9, img10, img11, img12, img13, img14, img15, img16,
    img17, img18, img19, img20, img21, img22, img23, img24,
    img25, img26, img27, img28
  ];

  return (
    <>
      <div className="pub-home-page-wrapper">
        <GridMotion items={gridItems} gradientColor="black" />

        <Container fluid className="p-0 position-relative" style={{ zIndex: 1 }}>
          {/* Hero Section */}
          <section id="home" className="pub-home-hero-full-section">
            <div className="pub-home-hero-overlay-dark" />
            <div className="pub-home-hero-content-container-fluid">
              <div className="pub-home-hero-text-content">
                <h1 className="pub-home-main-title">
                  Explore The Hidden Beauty Of Northern Pakistan
                </h1>
                <p className="pub-home-sub-title">
                  Book hotels, plan trips & explore destinations all in one place
                </p>
                <button
                  className="pub-home-enquiry-cta"
                  onClick={() => navigate('/aiplanner')}
                >
                  MAKE AN ENQUIRY
                  <span className="pub-home-arrow-icon">→</span>
                </button>
              </div>
            </div>
          </section>

          {/* Other Sections */}
          <div className="pub-home-content-sections-wrapper">
            <Container fluid className="p-0">
              <section id="packages">
                <PackageSlider />
              </section>
                <section id="about">
                  <AboutUs />
                </section>

              <section id="services">
                <Services />
              </section>
              <section id="testimonials">
                <TestimonialsSlider />
              </section>
            </Container>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Home;